import { configureStore } from '@reduxjs/toolkit'
import businessesReducer from './reducers/businessesReducer'
import authReducer from './reducers/authReducer'
import usersReducer from './reducers/usersReducer'

export default configureStore({
  reducer: {
    business: businessesReducer,
    auth: authReducer,
    user: usersReducer,
  }
})